import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EnrollmentRequiredDocumentType } from "../../../types/EnrollmentRequiredDocument";

const initialState: EnrollmentRequiredDocumentType = {
    description: "",
    status: false,
    id: ""
};
export const enrollmentRequiredDocumentSlice = createSlice({
    name: "enrollmentRequiredDocumentForm",
    initialState,
    reducers: {
        setUpdateEnrollmentRequiredDocumentData: (
            state, action: PayloadAction<EnrollmentRequiredDocumentType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUpdateEnrollmentRequiredDocumentData: (
            state,
        ) => {
            return initialState
        }
    }
});
export const { setUpdateEnrollmentRequiredDocumentData,resetUpdateEnrollmentRequiredDocumentData } = enrollmentRequiredDocumentSlice.actions;
export default enrollmentRequiredDocumentSlice.reducer;